'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';
import {
    SET_FUNCTIONS_ALTA_MOD_USUARIO,
    GET_DATA_ALTA_MOD_USUARIO_START,
    GET_DATA_ALTA_MOD_USUARIO_SUCCESS,
    SET_SELECTED_USER_ID_ALTA_MOD_USUARIO,
    UPDATE_INFORMACION_USUARIO_FROM_ALTA_MOD_USUARIO,
    GET_PERFILES_BY_PRODUCTO_FROM_ALTA_MOD_USUARIO,
    LIMPIAR_PERFILES_FILTRADOS,
    GET_PERFILES_FROM_ALTA_MOD_USUARIO,
    ADD_PERFIL_USUARIO_FROM_ALTA_MOD_USUARIO,
    DELETE_PERFIL_USUARIO_FROM_ALTA_MOD_USUARIO,
    ADD_PERMISO_ALTA_MOD_USUARIO,
    DELETE_PERMISO_ALTA_MOD_USUARIO,
    SELECT_PRODUCTO_PERMISOS_ALTA_MOD_USUARIO,
    SELECT_CATEGORIA_PERMISOS_ALTA_MOD_USUARIO,
    SELECT_PROGRAMA_PERMISOS_ALTA_MOD_USUARIO,
    ADD_FUNCION_ALTA_MOD_USUARIO,
    DELETE_FUNCION_ALTA_MOD_USUARIO,
    ADD_MODO_EXCLUSIVO_FROM_ALTA_MOD_USUARIO,
    DELETE_MODO_EXCLUSIVO_FROM_ALTA_MOD_USUARIO,
    SET_ACCESOS_PLATAFORMA_FROM_ALTA_MOD_USUARIO,
    SET_REDIRECT_TRUE_ALTA_MOD_USUARIO,
    RESET_STATE_ALTA_MOD_USUARIO,
    SET_POPUP_ALTA_MOD_USUARIO,
    ESCONDER_POPUP_ALTA_MOD_USUARIO,
    GET_DATA_AD_ALTA_MOD_USUARIO_SUCCESS,
    SET_PASSWORD_CHANGE_ALTA_MOD_USUARIO,
    SET_PASSWORD_UNCHANGE_ALTA_MOD_USUARIO,
    ADD_GRUPO_WINDOWS_USUARIO,
    DELETE_GRUPO_WINDOWS_USUARIO,
    RESET_GRUPO_WINDOWS_USUARIO,
    VALIDAR_COMBO_PERFILES
} from '../../Screens/AltaModUsuario/actions/AltaModUsuario';

const initialState = {
    isFetching: true,
    redirect: false,

    //Funciones de seguridad
    functions: undefined,

    selectedUserId: undefined,
    configuracionPwSesion: undefined,
    configuracionPwType: {},
    gruposWindows: [],
    sucursales: [],
    perfiles: [],
    perfilesFiltrados: [],
    sectores: [],
    tipoPlataforma: [],
    todosLosPrivilegios: false,
    esSeguridadGyf: true,
    accesosPorPlataforma: [],
    modoExclusivo: [],
    usuarioConCambios: false,


    informacionUsuario: {},
    perfilesDelUsuario: [],

    //Permisos
    productos: [],
    categorias: [],
    programas: [],
    funciones: [],
    permisos: [],

    //PopUp
    message: "",
    messageClass: "",
    messageHidden: true,

    passWordChange: false,
    initialData: {},

    gruposWindowsSeleccionados: [],

    usuariosActuales: [],

    productoSinPerfil: false,

    plataformaId: undefined,

};


function altaModUsuario(state = initialState, action) {
    LogHelper.In(altaModUsuario.name, state, action);

    let result;
    let tempResult;
    let temp;
    let itemToAdd;
    let itemToUpdate;
    let itemToDeleteIndex;
    let funciones;
    let itemGrupo;
    switch (action.type) {

        case SET_FUNCTIONS_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, state, action);

            result = {
                ...state,
                functions: action.functions
            };
            break;

        case SET_SELECTED_USER_ID_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, state, action);

            result = {
                ...state,
                selectedUserId: parseInt((action.userToEditId) ? action.userToEditId : "0")
            };
            break;

        case GET_DATA_ALTA_MOD_USUARIO_START:
            LogHelper.In(altaModUsuario.name, state, action);

            result = {
                ...state,
                isFetching: true
            };
            break;

        case VALIDAR_COMBO_PERFILES:
            LogHelper.In(altaModUsuario.name, state, action);
            result = {
                ...state,
                isFetching: false,
                productoSinPerfil: true
            };
            break;

        case GET_DATA_ALTA_MOD_USUARIO_SUCCESS:
            LogHelper.In(altaModUsuario.name, state, action);

            tempResult = action.result;
            tempResult.USER_INFO.NombreSinEditar = (tempResult.USER_INFO.Nombre) ? tempResult.USER_INFO.Nombre : "";
            sessionStorage.setItem('PantallaCambios', false);

            let fetching = (tempResult.USER_INFO) ? false : tempResult.CONFIGURATION_PASSWORD_TYPE.AltaAutomatica;
            let plataformaId = tempResult.GET_TIPO_PLATAFORMA && tempResult.GET_TIPO_PLATAFORMA.length > 0 ? tempResult.GET_TIPO_PLATAFORMA[0].Id : undefined;

            result = {
                ...state,
                isFetching: fetching,
                configuracionPwSesion: tempResult.CONFIGURATION_PASSWORD_SESION,
                configuracionPwType: tempResult.CONFIGURATION_PASSWORD_TYPE ? tempResult.CONFIGURATION_PASSWORD_TYPE : {},
                funciones: tempResult.GET_FUNCIONES,
                sucursales: tempResult.GET_SUCURSALES,
                perfiles: tempResult.GET_PERFILES,
                perfilesFiltrados: [],
                sectores: tempResult.GET_SECTORES,
                tipoPlataforma: tempResult.GET_TIPO_PLATAFORMA,
                productos: tempResult.GET_PRODUCTOS,
                categorias: tempResult.GET_CATEGORIAS,
                programas: tempResult.GET_PROGRAMAS,
                accesosPorPlataforma: tempResult.USER_ACCESS_BY_PLATAFORM,
                modoExclusivo: tempResult.USER_EXCLUSIVE_MODE,
                usuarioConCambios: false,
                informacionUsuario: tempResult.USER_INFO,
                perfilesDelUsuario: tempResult.USER_PROFILES,
                permisos: tempResult.USER_PERMISSION_COMBOS,
                gruposWindows: tempResult.GRUPOS_WINDOWS,
                initialData: tempResult.USER_INFO,
                usuariosActuales: tempResult.GET_ALL_USUARIOS,
                plataformaId,
            };

            break;

        case UPDATE_INFORMACION_USUARIO_FROM_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, state, action);

            temp = JSON.parse(JSON.stringify(state.informacionUsuario));
            temp[action.propToUpdate] = action.value;

            let productoSinPerfil = action.propToUpdate == "ProfileId" ? action.value > 0 ? false : true : state.productoSinPerfil;

            if (action.propToUpdate == "ProductId") {
                temp["ProfileId"] = undefined;
                productoSinPerfil = false;
            }

            sessionStorage.setItem('PantallaCambios', true);

            result = {
                ...state,
                informacionUsuario: temp,
                usuarioConCambios: true,
                productoSinPerfil
            };
            break;

        case GET_PERFILES_BY_PRODUCTO_FROM_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, state, action);

            result = {
                ...state,
                perfilesFiltrados: action.result.GET_PERFILES_BY_PRODUCTO,
            };
            break;

        case LIMPIAR_PERFILES_FILTRADOS:
            LogHelper.In(altaModUsuario.name, state, action);

            result = {
                ...state,
                perfilesFiltrados: [],
            };
            break;

        case GET_PERFILES_FROM_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, state, action);

            result = {
                ...state,
                isFetching: false,
                perfiles: action.result //.GET_PERFILES
            };
            break;

        case ADD_PERFIL_USUARIO_FROM_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, state, action);

            let productoText;

            temp = JSON.parse(JSON.stringify(state));
            if (!temp.perfilesDelUsuario.find(x => x.PerfilCodigo == action.perfilCodigo)) {
                itemToAdd = temp.perfiles.find(x => x.Codigo == action.perfilCodigo);
                itemToAdd.ProductoId = action.productId;

                if (itemToAdd.ProductoId != "0") {
                    state.productos.forEach((producto) => {

                        if (producto.Id == action.productId) {

                            productoText = producto.Descripcion;

                        }
                    });
                } else {
                    productoText = "Todos los productos";
                }

                temp.perfilesDelUsuario.push({
                    PerfilId: itemToAdd.Id,
                    PerfilDescripcion: itemToAdd.Codigo,
                    PerfilCodigo: itemToAdd.Codigo,
                    ProductoDescripcion: productoText,
                    ProductoId: action.productId
                });
            }

            sessionStorage.setItem('PantallaCambios', true);

            result = {
                ...state,
                perfilesDelUsuario: temp.perfilesDelUsuario,
                usuarioConCambios: true
            };
            break;

        case DELETE_PERFIL_USUARIO_FROM_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, state, action);

            itemToDeleteIndex = state.perfilesDelUsuario.findIndex(x => x.PerfilId == action.perfilId);

            state.informacionUsuario.profileId = undefined;

            temp = JSON.parse(JSON.stringify(state.perfilesDelUsuario));
            temp.splice(itemToDeleteIndex, 1);

            sessionStorage.setItem('PantallaCambios', true);

            result = {
                ...state,
                perfilesDelUsuario: temp,
                usuarioConCambios: true,
                productoSinPerfil: false
            };
            break;

        case ADD_PERMISO_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, state, action);
            sessionStorage.setItem('PantallaCambios', true);

            result = {
                ...state,
                permisos: action.permisos,
                usuarioConCambios: true
            };
            break;

        case DELETE_PERMISO_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, state, action);

            //itemToDeleteIndex = state.permisos.indexOf(action.permisoId);
            itemToDeleteIndex = state.permisos.findIndex(x => x.id == action.permisoId)

            temp = JSON.parse(JSON.stringify(state.permisos));
            temp.splice(itemToDeleteIndex, 1);
            sessionStorage.setItem('PantallaCambios', true);

            result = {
                ...state,
                permisos: temp,
                usuarioConCambios: true,
            };
            break;

        case SELECT_PRODUCTO_PERMISOS_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, state, action);

            temp = JSON.parse(JSON.stringify(state));

            funciones = [];
            action.result.funciones.forEach(function (funcion) {
                funciones.push({
                    id: funcion.Id,
                    descripcion: funcion.Descripcion
                });
            });

            //Rearmo los combos y los checks
            temp.permisos.find(x => x.id == action.result.idPermiso).productoId = action.result.idProducto;
            temp.permisos.find(x => x.id == action.result.idPermiso).categoriaId = 0;
            temp.permisos.find(x => x.id == action.result.idPermiso).programaId = 0;
            temp.permisos.find(x => x.id == action.result.idPermiso).listaFunciones = funciones;
            temp.permisos.find(x => x.id == action.result.idPermiso).funciones = [];
            temp.permisos.find(x => x.id == action.result.idPermiso).allowPermisos = false;


            sessionStorage.setItem('PantallaCambios', true);
            result = {
                ...state,
                permisos: temp.permisos,
                usuarioConCambios: true,
            };
            break;

        case SELECT_CATEGORIA_PERMISOS_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, state, action);

            temp = JSON.parse(JSON.stringify(state));

            funciones = [];
            action.result.funciones.forEach(function (funcion) {
                funciones.push({
                    id: funcion.Id,
                    descripcion: funcion.Descripcion
                });
            });

            //Rearmo los combos y los checks
            temp.permisos.find(x => x.id == action.result.idPermiso).categoriaId = action.result.idCategoria;
            temp.permisos.find(x => x.id == action.result.idPermiso).programaId = 0;
            temp.permisos.find(x => x.id == action.result.idPermiso).listaFunciones = funciones;
            temp.permisos.find(x => x.id == action.result.idPermiso).funciones = [];
            temp.permisos.find(x => x.id == action.result.idPermiso).allowPermisos = false;

            sessionStorage.setItem('PantallaCambios', true);
            result = {
                ...state,
                permisos: temp.permisos,
                usuarioConCambios: true,
            };
            break;

        case SELECT_PROGRAMA_PERMISOS_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, state, action);

            temp = JSON.parse(JSON.stringify(state));

            funciones = [];
            action.result.funciones.forEach(function (funcion) {
                funciones.push({
                    id: funcion.Id,
                    descripcion: funcion.Descripcion
                });
            });

            //Rearmo los combos y los checks
            temp.permisos.find(x => x.id == action.result.idPermiso).programaId = action.result.idPrograma;
            temp.permisos.find(x => x.id == action.result.idPermiso).listaFunciones = funciones;
            temp.permisos.find(x => x.id == action.result.idPermiso).funciones = [];
            temp.permisos.find(x => x.id == action.result.idPermiso).allowPermisos = action.result.idPrograma != 0;

            sessionStorage.setItem('PantallaCambios', true);
            result = {
                ...state,
                permisos: temp.permisos,
                usuarioConCambios: true,
            };
            break;

        case ADD_FUNCION_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, state, action);

            temp = JSON.parse(JSON.stringify(state));

            //Si la funcion no existe en el permiso
            if (!temp.permisos.find(x => x.id == action.idPermiso).funciones.find(x => x.id == action.idFuncion)) {
                //Inserto en las funciones del permiso la funcion seleccionada
                temp.permisos.find(x => x.id == action.idPermiso).funciones.push(
                    temp.permisos.find(x => x.id == action.idPermiso).listaFunciones.find(x => x.id == action.idFuncion));

                //Asigno si es otorgacion o restriccion
                temp.permisos.find(x => x.id == action.idPermiso).funciones.find(x => x.id == action.idFuncion).flag = action.flag;
            }

            sessionStorage.setItem('PantallaCambios', true);
            result = {
                ...state,
                permisos: temp.permisos,
                usuarioConCambios: true,
            };
            break;

        case DELETE_FUNCION_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, action, state);

            temp = JSON.parse(JSON.stringify(state));

            temp.permisos.find(x => x.id == action.idPermiso).funciones.splice(
                temp.permisos.find(x => x.id == action.idPermiso).funciones.findIndex(x => x.id == action.idFuncion), 1);


            sessionStorage.setItem('PantallaCambios', true);
            result = {
                ...state,
                permisos: temp.permisos,
                usuarioConCambios: true,
            };

            break;

        case ADD_MODO_EXCLUSIVO_FROM_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, state, action);

            if (action.modoExclusivo == 0) {
                temp = [];
                state.productos.forEach((x) => {
                    if (x.Id >= 0) {
                        temp.push(x.Id);
                    }
                });

            } else {
                temp = JSON.parse(JSON.stringify(state.modoExclusivo));
                temp.push(action.modoExclusivo);
            }

            sessionStorage.setItem('PantallaCambios', true);

            result = {
                ...state,
                modoExclusivo: temp,
                usuarioConCambios: true
            };
            break;

        case DELETE_MODO_EXCLUSIVO_FROM_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, state, action);

            itemToDeleteIndex = state.modoExclusivo.indexOf(action.modoExclusivo);

            temp = JSON.parse(JSON.stringify(state.modoExclusivo));
            temp.splice(itemToDeleteIndex, 1);

            let indexTodos = temp.indexOf(0);
            if (indexTodos !== -1)
                temp.splice(indexTodos, 1);

            if (state.productos.filter(x => x.Id >= 0).length == state.modoExclusivo.length && action.modoExclusivo == 0) {
                temp = [];
            }

            sessionStorage.setItem('PantallaCambios', true);

            result = {
                ...state,
                modoExclusivo: temp,
                usuarioConCambios: true
            };
            break;

        case SET_ACCESOS_PLATAFORMA_FROM_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, state, action);

            temp = JSON.parse(JSON.stringify(state.accesosPorPlataforma));

            itemToUpdate = temp.find(x => x.plataformaId == action.plataformaId);

            if (itemToUpdate) {
                itemToUpdate.value = action.plataforma;
            } else {
                itemToAdd = {
                    'plataformaId': action.plataformaId,
                    'value': action.plataforma
                };
                temp.push(itemToAdd);
            }

            sessionStorage.setItem('PantallaCambios', true);

            result = {
                ...state,
                accesosPorPlataforma: temp,
                usuarioConCambios: true
            };
            break;

        case SET_REDIRECT_TRUE_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, state, action);

            result = {
                ...state,
                isFetching: false,
                redirect: true
            };
            break;

        case RESET_STATE_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, state, action);

            result = initialState;
            break;

        case SET_POPUP_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, state, action);

            result = {
                ...state,
                isFetching: false,
                message: action.message.value,
                messageClass: action.message.class,
                messageHidden: false
            };
            break;

        case ESCONDER_POPUP_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, action, state);

            result = {
                ...state,
                message: "",
                messageClass: "",
                messageHidden: true
            };
            break;

        case GET_DATA_AD_ALTA_MOD_USUARIO_SUCCESS:
            LogHelper.In(altaModUsuario.name, action, state);

            result = {
                ...state,
                isFetching: false,
                gruposWindows: action.gruposWindows
            }
            break;

        case SET_PASSWORD_CHANGE_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, action, state);

            result = {
                ...state,
                passWordChange: true
            }

            break;

        case SET_PASSWORD_UNCHANGE_ALTA_MOD_USUARIO:
            LogHelper.In(altaModUsuario.name, action, state);

            result = {
                ...state,
                passWordChange: false
            }

            break;
        case ADD_GRUPO_WINDOWS_USUARIO:
            LogHelper.In(altaModUsuario.name, action)
            itemGrupo = {
                nombre: action.grupo
            }
            state.gruposWindowsSeleccionados.push(itemGrupo);
            result = {
                ...state,
                gruposWindowsSeleccionados: state.gruposWindowsSeleccionados
            }
            break;
        case DELETE_GRUPO_WINDOWS_USUARIO:
            LogHelper.In(altaModUsuario.name, action)
            itemGrupo = {
                nombre: action.grupo
            }
            let index = state.gruposWindowsSeleccionados.indexOf(itemGrupo)
            state.gruposWindowsSeleccionados.splice(index, 1)
            result = {
                ...state,
                gruposWindowsSeleccionados: state.gruposWindowsSeleccionados
            }
            break;
        case RESET_GRUPO_WINDOWS_USUARIO:
            LogHelper.In(altaModUsuario.name, action)
            result = {
                ...state,
                gruposWindowsSeleccionados: []
            }
            break;
        default:
            LogHelper.In(altaModUsuario.name, state, action);
            result = {
                ...state
            }
            break;
    }

    LogHelper.Out(altaModUsuario.name, result);
    return result;
}

export default altaModUsuario;